var map = {
	"./modules/auth/auth.module": [
		"./src/app/modules/auth/auth.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-auth-auth-module"
	],
	"./modules/categories/categories.module": [
		"./src/app/modules/categories/categories.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-categories-categories-module"
	],
	"./modules/company/company.module": [
		"./src/app/modules/company/company.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-company-company-module"
	],
	"./modules/contract/contract.module": [
		"./src/app/modules/contract/contract.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-contract-contract-module"
	],
	"./modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-dashboard-dashboard-module"
	],
	"./modules/declarations/declarations.module": [
		"./src/app/modules/declarations/declarations.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"common",
		"modules-declarations-declarations-module"
	],
	"./modules/employees/employees.module": [
		"./src/app/modules/employees/employees.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"common",
		"modules-employees-employees-module"
	],
	"./modules/isurrance-codes/isurrance-codes.module": [
		"./src/app/modules/isurrance-codes/isurrance-codes.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"common",
		"modules-isurrance-codes-isurrance-codes-module"
	],
	"./modules/register-ivan/register-ivan.module": [
		"./src/app/modules/register-ivan/register-ivan.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-register-ivan-register-ivan-module"
	],
	"./modules/register/register.module": [
		"./src/app/modules/register/register.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-register-register-module"
	],
	"./modules/system/accounts-management/accounts.module": [
		"./src/app/modules/system/accounts-management/accounts.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-system-accounts-management-accounts-module"
	],
	"./modules/system/emails-notification/emails-notification.module": [
		"./src/app/modules/system/emails-notification/emails-notification.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-system-emails-notification-emails-notification-module"
	],
	"./modules/system/products/products.module": [
		"./src/app/modules/system/products/products.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-system-products-products-module"
	],
	"./modules/system/research-connection/research-connection.module": [
		"./src/app/modules/system/research-connection/research-connection.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-system-research-connection-research-connection-module"
	],
	"./modules/system/search/search.module": [
		"./src/app/modules/system/search/search.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"modules-system-search-search-module"
	],
	"./modules/token/token.module": [
		"./src/app/modules/token/token.module.ts",
		"default~modules-auth-auth-module~modules-categories-categories-module~modules-company-company-module~7266943f",
		"common",
		"modules-token-token-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;